// 发音人语种
export const  FOREIGN  = [
    '英文','英语','德文','德语','俄语','俄文','法语','法文','韩语','韩文','日语','日文','西班牙语',
    '西班牙文','印尼语','印尼文','意大利语','意大利文','葡萄牙语','葡萄牙文','菲律宾语','菲律宾文','越南语','越南文','荷兰语','荷兰文','泰语',
    '泰文','南非','南非语','南非文'
  ]